// import React, { useEffect, useState, useRef } from "react";
// import { RiImageAddLine } from "react-icons/ri";
// import axios from "axios";
// import API_URL from "../config";

// const PostManagement = () => {
//   const [posts, setPosts] = useState([]);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [title, setTitle] = useState("");
//   const fileInputRef = useRef(null);

//   useEffect(() => {
//     fetchPosts();
//   }, []);

//   const fetchPosts = async () => {
//     try {
//       const response = await axios.get(`${API_URL}/post`);
//       setPosts(response.data.post);
//     } catch (error) {
//       console.error("Error fetching posts:", error);
//     }
//   };

//   const handleButtonClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setSelectedFile(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("title", title);
//     if (selectedFile) {
//       formData.append("image", selectedFile);
//     }

//     try {
//       if (posts) {
//         await axios.put(`${API_URL}/post`, formData);
//       } else {
//         await axios.post(`${API_URL}/post`, formData);
//       }
//       setTitle("");
//       setSelectedFile(null);
//       fetchPosts();
//     } catch (error) {
//       console.error("Error submitting post:", error);
//     }
//   };

//   return (
//     <div className="exerciseManagementContainer">
//       <div className="exerciseManagementHeader">
//         <div className="exerciseHeaderLeft">
//           <RiImageAddLine
//             size={30}
//             color="#ff0000"
//             style={{ marginRight: 10 }}
//           />
//           <h2>Post Management</h2>
//         </div>
//       </div>
//       <div className="postManagementFlex">
//         <div className="notificationMain">
//           <h2 style={{ textAlign: "left" }}>Add Post</h2>
//           <form onSubmit={handleSubmit} className="notificationInputMain">
//             <div className="addUserProfileInput">
//               <label>Title</label>
//               <input
//                 type="text"
//                 placeholder="Enter title"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 required
//               />
//             </div>
//             <div
//               className="dietPlainDiv"
//               style={{ marginTop: 14, marginBottom: 20 }}
//             >
//               <label>Select Image</label>
//               <div className="addAttachment">
//                 <button type="button" onClick={handleButtonClick}>
//                   +
//                 </button>
//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   style={{ display: "none" }}
//                   onChange={handleFileChange}
//                   accept="image/*"
//                 />
//               </div>
//             </div>
//             <div className="addUserBottomAggreementAndSaveButtonContainer">
//               <button type="submit">Post</button>
//             </div>
//           </form>
//         </div>
//         <div>
//           <h2 style={{ textAlign: "left" }}>Your Post</h2>
//           <div key={posts._id} className="postCard">
//             <img
//               src={`https://c3-fitness-science-backend.onrender.com/files/${posts?.image}`}
//               alt={posts.title}
//               className="postImage"
//             />
//             <h3>{posts.title}</h3>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PostManagement;

import React, { useEffect, useState, useRef } from "react";
import { RiImageAddLine } from "react-icons/ri";
import { useAdmin } from "../contexts/AdminContext";
import axios from "axios";
import API_URL from "../config";

const PostManagement = () => {
  const { admin } = useAdmin();
  const [posts, setPosts] = useState([]); // Changed to an array
  const [selectedFile, setSelectedFile] = useState(null);
  const [title, setTitle] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetchPosts();
  }, []);

  // Fetch all posts
  const fetchPosts = async () => {
    try {
      const response = await axios.get(`${API_URL}/post/${admin?.branch}`);
      setPosts(response.data.posts);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  // Handle file input button click
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  // Handle form submission to add a new post
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", title);
    formData.append("branch", admin?.branch);
    if (selectedFile) {
      formData.append("image", selectedFile);
    }

    try {
      await axios.post(`${API_URL}/post`, formData);
      setTitle("");
      setSelectedFile(null);
      fetchPosts(); // Refresh the list of posts
    } catch (error) {
      console.error("Error submitting post:", error);
    }
  };

  // Handle post deletion
  const handleDeletePost = async (postId) => {
    try {
      await axios.delete(`${API_URL}/post/${postId}/${admin?.branch}`);
      fetchPosts(); // Refresh the list of posts after deletion
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  return (
    <div className="exerciseManagementContainer">
      <div className="exerciseManagementHeader">
        <div className="exerciseHeaderLeft">
          <RiImageAddLine
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>Post Management</h2>
        </div>
      </div>
      <div className="postManagementFlex">
        <div className="notificationMain">
          <h2 style={{ textAlign: "left" }}>Add Post</h2>
          <form onSubmit={handleSubmit} className="notificationInputMain">
            <div className="addUserProfileInput">
              <label>Title</label>
              <input
                type="text"
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>
            <div
              className="dietPlainDiv"
              style={{ marginTop: 14, marginBottom: 20 }}
            >
              <label>Select Image</label>
              <div className="addAttachment">
                <button type="button" onClick={handleButtonClick}>
                  +
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
            </div>
            <div className="addUserBottomAggreementAndSaveButtonContainer">
              <button type="submit">Post</button>
            </div>
          </form>
        </div>
        <div>
          <h2 style={{ textAlign: "left", marginTop: 40 }}>Your Posts</h2>
          <div style={{ display: "flex", columnGap: 20 }}>
            {posts.map((post) => (
              <div key={post._id} className="postCard">
                <img
                  src={`https://api.c3fitnesssciencegymgmail.com/files/${post.image}`}
                  alt={post.title}
                  className="postImage"
                />
                <h3>{post.title}</h3>
                <button
                  onClick={() => handleDeletePost(post._id)}
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                    padding: "5px 10px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostManagement;
